import { call, put, takeEvery, all, delay, fork } from "redux-saga/effects"
import {
  getUserAPI,
  getEmployeeAPI,
  getSubscriptionStatus,
  getSubscriptionUsersAPI,
} from "./api"
import {
  GET_SU_USER_START,
  GET_SU_EMP_START,
  GET_SU_SUBS_START,
  GET_SU_SUBS_USERS_START,
} from "./constant"
import {
  getUserSuccess,
  getUserFail,
  getEmpSuccess,
  getEmpFail,
  getSubsPlanSuccess,
  getSubsPlanFail,
  getUserSubsPlanFail,
  getUserSubsPlanSuccess,
} from "./action"

function* SuperAdminFunc() {
  function* getUserAsync() {
    try {
      const response = yield call(getUserAPI)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getUserSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getUserFail(error))
    }
  }

  function* getUserAsyncFunc() {
    yield takeEvery(GET_SU_USER_START, getUserAsync)
  }

  // EMPLOYEE DETAILS :-)
  function* getEmpAsync(payload) {
    try {
      const response = yield call(getEmployeeAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getEmpSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getEmpFail(error))
    }
  }

  function* getEmpAsyncFunc() {
    yield takeEvery(GET_SU_EMP_START, getEmpAsync)
  }

  //Subscription Status :
  function* getSubPlanAsync(payload) {
    try {
      const response = yield call(getSubscriptionStatus, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getSubsPlanSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getSubsPlanFail(error))
    }
  }

  function* getSubPlanAsyncFunc() {
    yield takeEvery(GET_SU_SUBS_START, getSubPlanAsync)
  }

  // view user subscriptions
  function* getUserSubPlanAsync() {
    try {
      const response = yield call(getSubscriptionUsersAPI)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getUserSubsPlanSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getUserSubsPlanFail(error))
    }
  }

  function* getUserSubPlanAsyncFunc() {
    yield takeEvery(GET_SU_SUBS_USERS_START, getUserSubPlanAsync)
  }

  yield all([
    fork(getUserAsyncFunc),
    fork(getEmpAsyncFunc),
    fork(getSubPlanAsyncFunc),
    fork(getUserSubPlanAsyncFunc),
  ])
}

export default SuperAdminFunc
